export const environment = {
  production: false,
  endpoint:'https://backend.saudidigitalbazar.com/public/api',
  baseURL:'https://backend.saudidigitalbazar.com/public/api',
  currentUserKey:'qadiautkCurrentUser',
};